import {
  Component,
  Input,
} from '@angular/core';
import {HtmlViewerCkLazyComponentDefinition} from '../../../ck/html-viewer-ck/html-viewer-ck-lazy-component.definition';

@Component({
  selector: '<app-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrls: ['./html-viewer.component.scss']
})
export class HtmlViewerComponent {
  definition = HtmlViewerCkLazyComponentDefinition.getDefinition();
  @Input() html: string;
  instance = this;
}
